import { OtherNotesDraft } from "../../../../models/new/drafts/other-notes-draft.model";
import { Action } from "../../../action";

export enum OtherNotesDraftActionTypes {
  INDEX_REQUEST = "[Other Notes Drafts NEW] Index Request",
  INDEX_SUCCESS = "[Other Notes Drafts NEW] Index Success",

  CREATE_REQUEST = "[Other Notes Drafts NEW] Create Request",
  CREATE_SUCCESS = "[Other Notes Drafts NEW] Create Success",

  SHOW_REQUEST = "[Other Notes Drafts NEW] Show Request",
  SHOW_SUCCESS = "[Other Notes Drafts NEW] Show Success",

  UPDATE_REQUEST = "[Other Notes Drafts NEW] Update Request",
  UPDATE_SUCCESS = "[Other Notes Drafts NEW] Update Success",

  DELETE_REQUEST = "[Other Notes Drafts NEW] Delete Request",
  DELETE_SUCCESS = "[Other Notes Drafts NEW] Delete Success"
}

export class OtherNotesDraftIndexRequest implements Action {
  readonly type = OtherNotesDraftActionTypes.INDEX_REQUEST;
}

export class OtherNotesDraftIndexSuccess implements Action {
  readonly type = OtherNotesDraftActionTypes.INDEX_SUCCESS;

  constructor(public payload: OtherNotesDraft[]) {
  }
}

export class OtherNotesDraftCreateRequest implements Action {
  readonly type = OtherNotesDraftActionTypes.CREATE_REQUEST;
}

export class OtherNotesDraftCreateSuccess implements Action {
  readonly type = OtherNotesDraftActionTypes.CREATE_SUCCESS;

  constructor(public payload: OtherNotesDraft) {
  }
}

export class OtherNotesDraftShowRequest implements Action {
  readonly type = OtherNotesDraftActionTypes.SHOW_REQUEST;

  constructor(public payload: number) {

  }
}

export class OtherNotesDraftShowSuccess implements Action {
  readonly type = OtherNotesDraftActionTypes.SHOW_SUCCESS;

  constructor(public payload: OtherNotesDraft) {
  }
}

export class OtherNotesDraftUpdateRequest implements Action {
  readonly type = OtherNotesDraftActionTypes.UPDATE_REQUEST;

  constructor(public payload: number) {
  }
}

export class OtherNotesDraftUpdateSuccess implements Action {
  readonly type = OtherNotesDraftActionTypes.UPDATE_SUCCESS;

  constructor(public payload: OtherNotesDraft) {
  }
}

export class OtherNotesDraftDeleteRequest implements Action {
  readonly type = OtherNotesDraftActionTypes.DELETE_REQUEST;

  constructor(public payload: number) {
  }
}

export class OtherNotesDraftDeleteSuccess implements Action {
  readonly type = OtherNotesDraftActionTypes.DELETE_SUCCESS;

  constructor(public payload: number) {
  }
}
